module.exports = __webpack_public_path__ + "static/media/icon_197.bf03dfd1.svg";